import produce from "immer";
import { LoadState } from "../../constants/enums";
import { initialVinDecoderState } from "./vinDecoder.types";
import {
  DECODE_VIN_PROGRESS,
  DECODE_VIN_SUCCESS,
  DECODE_VIN_FAILED,
} from "./vinDecoderActions";

export const vinDecoderReducer = (
  state = initialVinDecoderState,
  action: any
) => {
  switch (action.type) {
    case DECODE_VIN_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.error = null;
      });
      return newState;
    }
    case DECODE_VIN_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }
    case DECODE_VIN_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }
    default: {
      return state;
    }
  }
};
